import { render, staticRenderFns } from "./enrolledCourses.vue?vue&type=template&id=2a88b98e&scoped=true&"
import script from "./enrolledCourses.vue?vue&type=script&lang=js&"
export * from "./enrolledCourses.vue?vue&type=script&lang=js&"
import style0 from "./enrolledCourses.vue?vue&type=style&index=0&id=2a88b98e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88b98e",
  null
  
)

export default component.exports